import { Component, OnDestroy, OnInit } from '@angular/core';
import { Constants } from '../../models/constants.class';
import { EntityInterface } from '../../models/entity.interface';
import { EntityService } from '../../services/entity.service';
import { normalize } from '../../helpers/string.utils';
import { EntityProductType } from '../../models/entity.definitions';
import { Router, ActivatedRoute } from '@angular/router';
import { CategorizerService } from '@app/services/categorizer.service';
import { NoPsd2Service } from '@app/services/no-psd2.service';
import { AggregatioRequestInterface } from '@app/models/aggregation.interface';
import { HttpErrorResponse } from '@angular/common/http';
import { SlideStates } from '@app/models/slide';
import { TealiumService } from '@app/services/tealium.service';
import { ConfigService } from '@ng-darwin/config';
import { WindowMessagesService } from '@app/services/window-messages.service';
import { interval, Subscription } from 'rxjs';

/**
 * @description Component
 * @class AgEntitiesSantanderCustomerComponent
 * @implements {OnInit} OnInit
 * @implements {OnDestroy} OnDestroy
 */
@Component({
  standalone: false,
  selector: 'app-ag-entities-santandercustomer',
  templateUrl: './ag-entities-santandercustomer.component.html',
  styleUrls: ['./ag-entities-santandercustomer.component.scss'],
})
export class AgEntitiesSantanderCustomerComponent implements OnInit, OnDestroy {
  public entities: Array<EntityInterface> = [];
  public entitiesAggregated: Array<EntityInterface> = [];
  public filteredEntities: Array<EntityInterface> = [];
  public constants = Constants;
  public filterText = '';
  public modalFilterText = '';
  public previousFilterText = '';
  public expedientCode = '';
  public selectedEntity: EntityInterface = {};
  public entitySantander: EntityInterface = {};
  public intervalCategorizer: any;
  public updatedEntities = false;
  public entitiesAggregatedLoad = false;
  public aggregatedError = false;
  public titularityError = false;
  public endSession = false;
  public finishError = false;
  public agreggatedOnCourse = false;
  public visibilityFinish = false;
  public allLoaded = false;
  public termsOK = false;
  public onlyAggregateSantander = false;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  public toggleHiddenEntities: SlideStates = SlideStates.CLOSE;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  public SlideStates = SlideStates;
  public otherEntities: Array<EntityInterface> = [];
  public duplicatedEntities: EntityInterface[] = [];
  private _endPoints: any;
  public intervalFinish: any;
  public isFinishing = false;
  public finishProcess = false;

  public totalSteps = 4;
  public actualStep = 1;
  public showModal = false;
  public selectedTab = 1;
  public isSoftCustomer = false;
  public hasNotEntities = true;
  public isAddMoreBanks = false;
  private _entitiesPollingInterval: any;
  public isCancel = true;
  private _isAdviseBack = false;
  private _appUnique = '';
  // eslint-disable-next-line @typescript-eslint/naming-convention
  public _onlySantanderUrlParam = false;
  onlySantanderQueryParam: any = null;
  public currentSelectedEntities: any;

  /**
   * @description Creates an instance of AgEntitiesSantanderCustomerComponent.
   * @param router Router
   * @param entityService EntityService
   * @param categorizerService CategorizerService
   * @param noPsd2Service NoPsd2Service
   * @param _activatedRoute ActivatedRoute
   * @param _tealiumService TealiumService
   * @param _configService ConfigService
   * @param _windowMessagesService WindowMessagesService
   */
  constructor(
    public readonly router: Router,
    public readonly entityService: EntityService,
    public readonly categorizerService: CategorizerService,
    public readonly noPsd2Service: NoPsd2Service,
    private _activatedRoute: ActivatedRoute,
    private readonly _tealiumService: TealiumService,
    private readonly _configService: ConfigService,
    private readonly _windowMessagesService: WindowMessagesService,
    private readonly _categorizerService: CategorizerService,
  ) {
    const appConfig = this._configService.config.app || {};
    this._endPoints = appConfig['endPoints'] || {};
    this.expedientCode = sessionStorage.getItem('prop-unique-id') as string;
    const addMoreBanks = sessionStorage.getItem('addMoreBanks');
    const adviseBack = sessionStorage.getItem('adviseBack');
    if (adviseBack) {
      this.isAddMoreBanks = JSON.parse(adviseBack);
    }
    if (addMoreBanks) {
      this.isAddMoreBanks = JSON.parse(addMoreBanks);
    }
    if (!sessionStorage.getItem('isCompanyUser')) {
      this.termsOK = true;
    }
    this.finishProcess =
      JSON.parse(sessionStorage.getItem('finishProcess') as string) || false;
  }

  /**
   * @description ngOnInit
   */
  ngOnInit(): void {
    this.currentSelectedEntities =
      JSON.parse(sessionStorage.getItem('selectedEntities')!) ?? undefined;
    this._appUnique = sessionStorage.getItem('app-unique-id') as string;
    sessionStorage.removeItem('selectedEntities');
    this.entityService.removeSelectedEntities();
    const terms = JSON.parse(sessionStorage.getItem('terms') || '{}');
    if (terms.expedientCode === this.expedientCode) {
      this.termsOK = terms.terms;
    }
    if (this.termsOK) {
      this.pageLoadTealium();
      this.getAndSortEntities();
    }
    this.onlySantanderQueryParam =
      JSON.parse(sessionStorage.getItem('onlySantander')!) ?? false;
  }

  setWidth(): any {
    let percentge = (this.actualStep * 100) / this.totalSteps;
    let styles = {
      width: percentge + '%',
    };
    return styles;
  }

  pageLoadTealium(): void {
    this._tealiumService.sendPageLoad({
      page_name: '/PSD2/agregar_banco/seleccion_banco',
      page_title: 'PSD2 agregar banco selección banco',
      page_type: 'detalle',
      page_category: 'servicing',
      product_scope: 'operativa_no_financiera',
      product_category: 'PSD2',
      product_name: 'crédito digital',
    });
  }

  /**
   * @description getAndSortEntities
   */
  getAndSortEntities(): void {
    this.entityService.getEntities().then(
      (entities) => {
        const aspspcode = sessionStorage.getItem('ASPSP');
        const consentId = sessionStorage.getItem('consentId');

        if (aspspcode && consentId) {
          this.entityService.setSelectedEntity(
            entities.find((entity) => entity.code === aspspcode) || {},
          );
          sessionStorage.removeItem('ASPSP');
          console.log('navegación a messages ag-entities-softcustomer');
          this.router.navigate([Constants.url.messages]);
          return;
        }

        if (this.isWebview() && this.hasEntitiesState()) {
          this.router.navigate([Constants.url.loader]);
          return;
        }

        this._onlySantanderUrlParam =
          JSON.parse(sessionStorage.getItem('onlySantander')!) ?? false;
        this._onlySantanderUrlParam && (this.onlyAggregateSantander = true);
        this.entities = entities;
        this.otherEntities = this.getOtherEntities();
        this.filteredEntities = [...this.getDefaultEntities()];
        if (!this.expedientCode) {
          this.aggregatedError = true;
        }
        this.aggregationNoPsd2(this._onlySantanderUrlParam);
      },
      () => {
        this.aggregatedError = true;
      },
    );
  }

  /**
   * @description getDefaultEntities
   * @returns EntityInterface[]
   */
  getDefaultEntities(): EntityInterface[] {
    return this.entities
      .filter((entity) => entity.main)
      .sort((entityA, entityB) => {
        const orderA = entityA.order ? entityA.order : 9999;
        const orderB = entityB.order ? entityB.order : 9999;
        return orderA - orderB;
      });
  }

  /**
   * @description getOtherEntities
   * @returns EntityInterface[]
   */
  getOtherEntities(): EntityInterface[] {
    return this.entities
      .filter((entity) => !entity.main)
      .sort((entityA, entityB) => {
        const orderA = entityA.order ? 9998 : 9999;
        const orderB = entityB.order ? 9998 : 9999;
        return orderA - orderB;
      });
  }

  /**
   * @description getCategorizerEntities
   * @param onlySantander boolean default=false
   */
  getCategorizerEntities(onlySantander = false): void {
    this.categorizerService
      .getEntities(this.expedientCode, this._onlySantanderUrlParam)
      .then(
        (entities) => {
          this.entitiesAggregatedLoad = true;
          this.duplicatedEntities = entities.map(
            (a) => this.entities.find((e) => e.code === a.code) || {},
          );
          this.entities = this.entities.filter(
            (val) => !this.duplicatedEntities.includes(val),
          );
          this.entitySantander =
            entities.find((e) => e.code === Constants.santanderCode) || {};
          this.manageSantanderStatus(onlySantander);
          if (!onlySantander) {
            this.entitiesAggregated = entities.reduce(
              (finalArray: EntityInterface[], currentEntity) => {
                if (
                  currentEntity !== this.entitySantander &&
                  !finalArray.some(
                    (entityFound) => entityFound.code === currentEntity.code,
                  )
                ) {
                  finalArray.push(currentEntity);
                }
                return finalArray;
              },
              [],
            );
            //en caso de tener bancos agregados y no tener la opcion isAddMoreBanks ni isAdviseBack, se entiende que es la primera carga
            //del componente (primera vez que accede el usuario) y que seguramente venga de la opcion "retomar"
            //por lo que se debe redirigir a entities-progress
            if (
              this.entitiesAggregated[0] != null &&
              this.entitiesAggregated[0] != undefined &&
              !this.isAddMoreBanks &&
              !this._isAdviseBack
            ) {
              sessionStorage.setItem(
                'selectEntitiesBanks',
                JSON.stringify(this.entitiesAggregated),
              );
              sessionStorage.setItem('goBack', JSON.stringify(true));
              this.setSelectedEntities();
              this.router.navigate(['/entities-progress']);
            }

            const foundIndex = this.entitiesAggregated.findIndex(
              (e) =>
                e.status === Constants.statusNames.oncourse ||
                e.status === Constants.statusNames.validating,
            );
            if (foundIndex !== -1) {
              this.agreggatedOnCourse = true;
            } else {
              clearInterval(this.intervalCategorizer);
              this.agreggatedOnCourse = false;
            }
            this.updateEntities();
            if (this.entities.length > 0) {
              this.allLoaded = true;
              if (this.finishProcess) {
                sessionStorage.removeItem('finishProcess');
                this.finish(!this.isCancel, false);
              }
            }
          }
          this.checkFinishVisibility();
        },
        () => {
          this.aggregatedError = true;
          clearInterval(this.intervalCategorizer);
        },
      );
  }

  /**
   * @description manageSantanderStatus
   * @param onlySantander boolean default=false
   */
  manageSantanderStatus(onlySantander = false): void {
    if (
      (this.entitySantander.status === Constants.statusNames.ok &&
        onlySantander) ||
      this.entitySantander.status === Constants.statusNames.ko
    ) {
      clearInterval(this.intervalCategorizer);
    }
    if (
      this.entitySantander.status === Constants.statusNames.ko &&
      this.entitySantander.statusMessage === Constants.statusNames.nonOwner
    ) {
      this.titularityError = true;
    }
    if (
      this.entitySantander.status === Constants.statusNames.ko &&
      this.entitySantander.statusMessage !== Constants.statusNames.nonOwner
    ) {
      this.aggregatedError = true;
    }
    this.checkFinishVisibility();
  }

  /**
   * @description getCategorizerEntitySantander
   */
  getCategorizerEntitySantander(): void {
    this.categorizerService
      .getEntities(this.expedientCode, this._onlySantanderUrlParam)
      .then((entities) => {
        this.entitySantander =
          entities.find((e) => e.code === Constants.santanderCode) || {};
        if (this.entitySantander.status === Constants.statusNames.ko) {
          this.aggregatedError = true;
          this.finishError = true;
          this._tealiumService.sendError({
            category: 'Santander error',
            action: 'error',
            data: {
              cod_error: 500,
              desc_error: 'ADN service',
            },
          });
          clearInterval(this.intervalCategorizer);
        }
        if (this.entitySantander.status === Constants.statusNames.ok) {
          clearInterval(this.intervalCategorizer);
        }
        this.checkFinishVisibility();
      });
  }

  /**
   * @description se llama cuando únicamente queremos comprobar que autoconsumo esté bien
   */
  aggregationDoneSantanderFunc(): void {
    this.getCategorizerEntities(true);
    this.intervalCategorizer = setInterval(() => {
      this.getCategorizerEntitySantander();
    }, 2000);
  }

  /**
   * @param value boolean
   * @description se llama cuando queremos únicamente agregar santander
   */
  goToAggregateSantander(value: boolean): void {
    this.aggregationNoPsd2(value);
    this._tealiumService.sendEvent({
      category: 'PSD2 Agregador',
      action: 'select_content',
      data: {
        product_name: 'crédito digital',
        product_category: 'PSD2',
        content_type: 'PSD2_agregador',
        item_id: 'checkbox_solo_cliente_santander',
        label: 'Checkbox solo cliente santander',
      },
    });
  }

  /**
   * @description Condición necesaria para que el botón de "solo soy cliente de banco santander" esté habilitado
   * @returns boolean
   */
  canAggregateOnlySantander(): boolean {
    return (
      !this.entitiesAggregated ||
      this.entitiesAggregated.length === 0 ||
      this.entitiesAggregated.findIndex(
        (entity) =>
          entity.status === Constants.statusNames.success ||
          (entity.status &&
            entity.status.toLowerCase() === Constants.statusNames.oncourse),
      ) === -1
    );
  }

  /**
   * @description selectEntity
   * @param entity EntityInterface
   */
  selectEntity(entity: EntityInterface): void {
    this.entityService.setSelectedEntities(entity);
  }

  /**
   * @description entityButtonClasses
   * @param entity EntityInterface
   * @returns string
   */
  entityButtonClasses(entity: EntityInterface): string {
    return `btn btn-entity ${this.isThisEntitySelected(entity) && 'active'}`;
  }

  /**
   * @description isEntitySelected
   * @returns boolean
   */
  isEntitySelected(): boolean {
    return Object.keys(this.entityService.getSelectedEntities()).length > 0;
  }

  /**
   * @description isThisEntitySelected
   * @param entity EntityInterface
   * @returns boolean
   */
  isThisEntitySelected(entity: EntityInterface): boolean {
    if (this.isEntitySelected()) {
      const entityFound = this.entityService
        .getSelectedEntities()
        .find((ent) => ent.name === entity.name);
      return entityFound ? true : false;
    } else {
      return false;
    }
  }

  /**
   * @description updateEntities
   */
  updateEntities(): void {
    if (this.filterText.length > 2) {
      this.filteredEntities = [
        ...this.entities.filter(
          (entity) =>
            entity.name &&
            new RegExp(normalize(this.filterText), 'g').test(
              normalize(entity.name),
            ),
        ),
      ];
      this.otherEntities = [...this.filteredEntities];
      if (
        (this.previousFilterText?.length <= this.filterText?.length &&
          this.filterText?.length === 3) ||
        (!this.previousFilterText && this.filterText?.length >= 3)
      ) {
        this._tealiumService.sendEvent({
          category: 'PSD2 Agregador',
          action: 'filter',
          data: {
            product_name: 'crédito digital',
            product_category: 'PSD2',
            product_subcategory: this.filterText,
            filter_category: 'bank',
            label: 'Pulsa filtrar entidad',
          },
        });
      }
    } else {
      this.filteredEntities = [...this.getDefaultEntities()];
      this.otherEntities = [...this.getOtherEntities()];
    }
    this.previousFilterText = this.filterText;
    this.updatedEntities = true;
  }

  updateModalEntities(): void {
    const normalizedFilter = normalize(this.modalFilterText.trim());

    this.otherEntities =
      normalizedFilter.length > 0
        ? this.getAllEntities().filter(
            (entity) =>
              entity.name && normalize(entity.name).includes(normalizedFilter),
          )
        : this.getAllEntities();
  }

  getAllEntities(): EntityInterface[] {
    return [...this.entities].sort((entityA, entityB) => {
      const orderA = entityA.order ?? 9999;
      const orderB = entityB.order ?? 9999;
      return orderA - orderB;
    });
  }

  getEntitiesToDisplay(): EntityInterface[] {
    const selectedEntities = this.entityService.getSelectedEntities();
    const entitiesToDisplay = [...this.entitiesAggregated, ...selectedEntities];

    return entitiesToDisplay.filter(
      (entity, index, entities) =>
        entity.code &&
        entities.findIndex((item) => item.code === entity.code) === index,
    );
  }

  isCurrentlySelected(entity: EntityInterface): boolean {
    return this.entityService
      .getSelectedEntities()
      .some((selectedEntity) => selectedEntity.code === entity.code);
  }

  removeSelectedEntity(entity: EntityInterface): void {
    if (this.isCurrentlySelected(entity)) {
      this.entityService.setSelectedEntities(entity);
    }
  }

  /**
   * @description aggregationNoPsd2
   * @param onlySantander boolean default=false
   */
  aggregationNoPsd2(onlySantander = false): void {
    if (this.intervalCategorizer) {
      clearInterval(this.intervalCategorizer);
    }
    const noPsd2Request: AggregatioRequestInterface = {
      aspspcode: Constants.santanderCode,
      products: ['Accounts'],
      expedientCode: this.expedientCode,
      credentials: [],
    };
    this.noPsd2Service
      .postAggregation(noPsd2Request)
      .then(() => {
        if (onlySantander) {
          this.aggregationDoneSantanderFunc();
        } else {
          this.aggregationDoneFunc();
        }
      })
      .catch((error: HttpErrorResponse) => {
        this._tealiumService.sendError({
          category: error.message,
          action: 'error',
          data: {
            cod_error: error.status,
            desc_error: this._endPoints.psd2,
          },
        });
        this.aggregatedError = true;
      });
  }

  /**
   * @description aggregationDoneFunc
   */
  aggregationDoneFunc(): void {
    this.getCategorizerEntities();
    this.intervalCategorizer = setInterval(() => {
      this.getCategorizerEntities();
    }, 2000);
  }

  /**
   * @description checkFinishVisibility
   */
  checkFinishVisibility(): void {
    const allEntities = this.entitiesAggregated.concat([this.entitySantander]);
    const isAnyEntityOk =
      allEntities.find((e) => e.status === Constants.statusNames.ok) !==
      undefined;
    const isAllAggregationsCompleted =
      this.entitiesAggregatedLoad === true && this.agreggatedOnCourse === false;

    if (
      (allEntities.length > 1 && isAnyEntityOk && isAllAggregationsCompleted) ||
      (this.onlyAggregateSantander &&
        this.canAggregateOnlySantander() &&
        this.entitySantander.status === this.constants.statusNames.ok)
    ) {
      if (this._onlySantanderUrlParam) {
        this.finish(!this.isCancel, false);
      }
      this.visibilityFinish = true;
    } else {
      this.visibilityFinish = false;
    }
  }

  /**
   * @description finish
   */
  finish(cancel: boolean, back: boolean): void {
    //this.isFinishing = false;
    this.finishError = false;
    this.aggregatedError = false;
    if (
      (this.onlyAggregateSantander &&
        this.entitySantander.status !== Constants.statusNames.ok) ||
      cancel
    ) {
      // this.aggregatedError = true;
      // this.finishError = true;
      if (this.isAddMoreBanks && back) {
        sessionStorage.setItem('goBack', JSON.stringify(true));
        this.setSelectedEntities();
        this.router.navigate(['/entities-progress']);
      } else {
        this._windowMessagesService.cancel();
        this._tealiumService.sendError({
          category: 'Santander aggregation error',
          action: 'error',
          data: {
            cod_error: 500,
            desc_error: 'ADN service',
          },
        });
      }
    } else {
      this.categorizerService.putEntities(this.expedientCode).then(
        (response) => {
          clearInterval(this.intervalCategorizer);
          if (response.status === 202) {
            this.checkIfProcessIsFinished(response.body.processId, cancel);
          } else {
            this.finishError = true;
            this._tealiumService.sendError({
              category: 'Finish error',
              action: 'warning',
              data: {
                cod_error: 400,
                desc_error: this._endPoints.categorizer,
              },
            });
          }
        },
        () => {
          this._tealiumService.sendError({
            category: 'Finish error',
            action: 'error',
            data: {
              cod_error: 500,
              desc_error: this._endPoints.categorizer,
            },
          });
          this.aggregatedError = true;
        },
      );
    }
  }

  checkIfProcessIsFinished(processId: string, cancel: boolean): void {
    if (!this.isAddMoreBanks) {
      this.isFinishing = true;
    }
    let numberOfCalls = 0;
    this.intervalFinish = setInterval(() => {
      numberOfCalls += 1;
      if (numberOfCalls > 30) {
        this.isFinishing = false;
        this.aggregatedError = true;
        this.finishError = true;
        clearInterval(this.intervalFinish);
      } else {
        this.getProcessStatus(processId, cancel);
      }
    }, 1000);
  }

  getProcessStatus(processId: string, cancel: boolean): void {
    this.categorizerService
      .getProcessStatus(processId)
      .then((status) => {
        if (
          (status.body.processStatus as string)?.toLowerCase() !== 'pending'
        ) {
          this.isFinishing = false;
          clearInterval(this.intervalFinish);
          this.categorizerService.isProcessFinished = true;
          this.visibilityFinish = false;
          this._tealiumService.sendEvent({
            category: 'PSD2 Agregador',
            action: 'end_process',
            data: {
              product_name: 'crédito digital',
              product_category: 'PSD2',
            },
          });
          this.goOutApp(cancel);
        }
      })
      .catch(() => {
        this.isFinishing = false;
        this.aggregatedError = true;
        this.finishError = true;
        clearInterval(this.intervalFinish);
      });
  }

  /**
   * @description allowTerms
   */
  allowTerms(): void {
    this.termsOK = true;
    const terms = {
      terms: this.termsOK,
      expedientCode:
        this.expedientCode !== null
          ? this.expedientCode
          : (this._activatedRoute.snapshot.queryParamMap.get(
              'prop-unique-id',
            ) as string),
    };
    sessionStorage.setItem('terms', JSON.stringify(terms));
    this.getAndSortEntities();
  }

  /**
   * @description allowTermsSantander - salta la pantalla de selección de bancos cuando el usuario solo tiene cuenta en Santander
   */
  allowTermsSantander(): void {
    this.termsOK = true;
    const terms = {
      terms: this.termsOK,
      expedientCode:
        this.expedientCode !== null
          ? this.expedientCode
          : (this._activatedRoute.snapshot.queryParamMap.get(
              'prop-unique-id',
            ) as string),
    };
    sessionStorage.setItem('terms', JSON.stringify(terms));
    this.onlyAggregateSantander = true;
    this._onlySantanderUrlParam = true;
    this.goToAggregateSantander(true);
  }

  /**
   * @description cancelTerms
   */
  cancelTerms(): void {
    this._windowMessagesService.cancel();
  }

  /**
   * @description toggleSlideState
   */
  toggleSlideState(): void {
    // eslint-disable @typescript-eslint/naming-convention
    if (this.toggleHiddenEntities === SlideStates.CLOSE) {
      this.toggleHiddenEntities = SlideStates.OPEN;
    } else {
      this.toggleHiddenEntities = SlideStates.CLOSE;
      // eslint-enable @typescript-eslint/naming-convention
    }
  }

  /**
   * @description continue
   */
  continue(): void {
    if (this.isEntitySelected()) {
      const entities = this.entityService.getSelectedEntities();
      entities.forEach((entity) => {
        const products = entity.products || [];
        const hasPsd2Products = products.findIndex(
          (product) => product.type === EntityProductType.psd2,
        );
        if (hasPsd2Products !== -1) {
          this.entityService.setSelectedEntityProductType(
            EntityProductType.psd2,
          );
          Promise.resolve(this.router.navigate([Constants.url.terms]));
        }
      });
    }
  }

  /**
   * @description navigateToDetail
   * @param entityCode string
   */
  navigateToDetail(entityCode: string): void {
    const entity =
      this.entitiesAggregated.find(
        (entityFound) => entityFound.code === entityCode,
      ) || {};
    const entityDetail =
      this.duplicatedEntities.find(
        (entityFound) => entityFound.code === entityCode,
      ) || {};
    this.entityService.setCategorizerEntity(entity);
    this.entityService.setSelectedEntity(entityDetail);
    clearInterval(this.intervalCategorizer);
    this.router.navigate([Constants.url.entityDetail]);
  }

  setSelectedEntities(): void {
    if (this.currentSelectedEntities) {
      this.currentSelectedEntities?.forEach((e: any) => {
        this.entityService.setSelectedEntities(e);
      });
      sessionStorage.setItem(
        'selectedEntities',
        JSON.stringify(this.currentSelectedEntities),
      );
    }
  }

  /**
   * @description goOutApp
   */
  goOutApp(cancel: boolean): void {
    if (this.isAddMoreBanks) {
      sessionStorage.setItem('goBack', JSON.stringify(true));
      this.setSelectedEntities();
      this.router.navigate(['/entities-progress']);
    } else if (this.onlyAggregateSantander) {
      this._windowMessagesService.end();
    } else {
      console.warn('[Process] Getting out app');
      this._windowMessagesService.cancel();
      if (this.termsOK) {
        this.endSession = true;
      }
    }
  }

  /**
   * @description goOutAppWithError
   */
  goOutAppWithError(): void {
    this._windowMessagesService.error();
    if (this.termsOK) {
      this.endSession = true;
    }
  }

  selectTab(i: number): void {
    this.selectedTab = i;
  }

  /**
   * @description ngOnDestroy
   */
  ngOnDestroy(): void {
    sessionStorage.removeItem('adviseBack');
    sessionStorage.removeItem('addMoreBanks');
    clearInterval(this.intervalCategorizer);
  }

  openModal(): void {
    this.modalFilterText = '';
    this.updateModalEntities();
    this.showModal = true;
  }

  closeModal(): void {
    this.showModal = false;
    this.modalFilterText = '';
    this.updateModalEntities();
  }

  checkEntities(): boolean {
    return (this.hasNotEntities =
      this.entityService.getSelectedEntities().length === 0);
  }

  navigateToAdvise(): void {
    this.router.navigate(['/advise-banner']);
  }

  /**
   * Check wether is webview or not.
   */
  isWebview(): boolean {
    return JSON.parse(sessionStorage.getItem('iswebview') ?? 'false');
  }

  hasEntitiesState(): boolean {
    return !!sessionStorage.getItem('entitiesState');
  }
}
